export const CASES = {
    UPDATE_RIGHTS: 'UPDATE_RIGHTS',
    UPDATE_RIGHTS_FORM: 'UPDATE_RIGHTS_FORM',
    CLEAR_ASSOCIATIONS_DRAWER: 'CLEAR_ASSOCIATIONS_DRAWER',
    CLEAR_RIGHTS: 'CLEAR_RIGHTS',
};
